import React, {Component} from "react";
import Button from "react-toolbox/lib/button/Button";
import PropTypes from "prop-types";
import "../brand_theme.css";

class PayableSummary extends Component {
	constructor(props) {
		super(props);

		this.payNow = this.payNow.bind(this);
		this.calculateTotals = this.calculateTotals.bind(this);

		this.state = {
			pastDueInvoicePaymentTotal: null,
			currentInvoicePaymentTotal: null,
			prepaidAdPaymentTotal: null,
			billedAdPaymentTotal: null
		};
	}

	payNow() {
		this.props.payAction();
	}

	calculateTotals() {
		this.pastDueTotal = this.props.pastDueInvoices ? this.props.pastDueInvoices
			.reduce((total, invoice) => total = total + invoice.receivable, 0) : 0.00;
		this.currentTotal = this.props.currentInvoices ? this.props.currentInvoices
			.reduce((total, invoice) => total = total + invoice.receivable, 0) : 0.00;
		this.prepaidAdTotal = this.props.prepaidAds ? this.props.prepaidAds
			.reduce((total, ad) => total = total + ad.totalUnpaid, 0) : 0.00;
		this.billedAdTotal = this.props.unbilledAds ? this.props.unbilledAds
			.reduce((total, ad) => total = total + ad.totalUnpaid, 0) : 0.00;

		this.totalPayable = this.pastDueTotal + this.currentTotal + this.prepaidAdTotal + this.billedAdTotal;
	}

	render() {
		this.calculateTotals();

		let pdiPayment = this.props.pastDueInvoicePaymentTotal ?
			<td className="money selectPaymentSummary">{this.props.pastDueInvoicePaymentTotal.formatMoney()}</td> : null;
		let PastDueInvoiceLine = () => this.pastDueTotal > 0 ?
			<tr>
				<th className="money">Past Due Invoices:</th>
				<td className="money highlightProblem payableAmountColumn">{this.pastDueTotal.formatMoney()}</td>
				{pdiPayment}
			</tr> :
			<tr></tr>;
		let ppaPayment = this.props.prepaidAdPaymentTotal ?
			<td className="money selectPaymentSummary">{this.props.prepaidAdPaymentTotal.formatMoney()}</td> : null;
		let PrepayAdLine = () => this.prepaidAdTotal > 0 ?
			<tr>
				<th className="money">Ads Requiring Prepayment:</th>
				<td className="money payableAmountColumn">{this.prepaidAdTotal.formatMoney()}</td>
				{ppaPayment}
			</tr> :
			<tr></tr>;
		let ciPayment = this.props.currentInvoicePaymentTotal ?
			<td className="money selectPaymentSummary">{this.props.currentInvoicePaymentTotal.formatMoney()}</td> : null;
		let RecentInvoiceLine = () => this.currentTotal > 0 ?
			<tr>
				<th className="money">Current Invoices:</th>
				<td className="money payableAmountColumn">{this.currentTotal.formatMoney()}</td>
				{ciPayment}
			</tr> :
			<tr></tr>;
		let baPayment = this.props.billedAdPaymentTotal ?
			<td className="money selectPaymentSummary">{this.props.billedAdPaymentTotal.formatMoney()}</td> : null;
		let BilledAdLine = () => this.billedAdTotal > 0 ?
			<tr>
				<th className="money">Ads Not Yet Invoiced:</th>
				<td className="money payableAmountColumn">{this.billedAdTotal.formatMoney()}</td>
				{baPayment}
			</tr> :
			<tr></tr>;

		let totalPayment =
			(this.props.pastDueInvoicePaymentTotal ? this.props.pastDueInvoicePaymentTotal : 0.00) +
			(this.props.prepaidAdPaymentTotal ? this.props.prepaidAdPaymentTotal : 0.00) +
			(this.props.currentInvoicePaymentTotal ? this.props.currentInvoicePaymentTotal : 0.00) +
			(this.props.billedAdPaymentTotal ? this.props.billedAdPaymentTotal : 0.00);
		let totalPaymentCell = totalPayment > 0.00 ?
			<td className="money selectPaymentSummary">{totalPayment.formatMoney()}</td> :
			<td className="money selectPaymentSummary"> </td>;
		let buttonCell = totalPayment > 0.00 ?
			<td id="summaryPayButton">
				<Button
					raised primary
					onClick={this.payNow}
				>
					Pay Now
				</Button>
			</td> : null;
		let TotalLine = () => this.totalPayable > 0 ?
			<tr>
				<th className="money">Total:</th>
				<td className="money payableAmountColumn"><strong>{this.totalPayable.formatMoney()}</strong></td>
				{totalPaymentCell}
				{buttonCell}
			</tr> :
			<tr></tr>;

		// let ButtonLine = () => totalPayment > 0 ?
		// 	<tr>
		// 		<td></td>
		// 		<td></td>
		// 		<td id="summaryPayButton">
		// 			<Button
		// 				raised primary
		// 				onClick={this.payNow}
		// 			>
		// 				Pay Now
		// 			</Button>
		// 		</td>
		// 	</tr> : null;



		let payHeader = <th className="money selectPaymentSummary">Total Selected For Payment</th>;


		let dateOpts = { month: "long", day:"numeric", year:"numeric"};
		let todayStr = new Date().toLocaleDateString("en-US", dateOpts);


		return (

			<div className="CustomerAccountInfo-PayableSummary">
				<h2>Summary as of {todayStr}</h2>
				<table>
					<thead>
						<tr>
							<th></th>
							<th className="money">Payable</th>
							{payHeader}
						</tr>
					</thead>
					<tbody>
						<PastDueInvoiceLine />
						<PrepayAdLine />
						<RecentInvoiceLine />
						<BilledAdLine />
					</tbody>
					<tfoot>
						<TotalLine />
					</tfoot>
				</table>
			</div>
		);
	}
}

PayableSummary.propTypes = {
	payAction: PropTypes.func,
	paymentConfig: PropTypes.object,
	currentInvoices: PropTypes.array,
	pastDueInvoices: PropTypes.array,
	payments: PropTypes.array,
	prepaidAds: PropTypes.array,
	unbilledAds: PropTypes.array,
	pastDueInvoicePaymentTotal: PropTypes.number,
	currentInvoicePaymentTotal: PropTypes.number,
	prepaidAdPaymentTotal: PropTypes.number,
	billedAdPaymentTotal: PropTypes.number
};

export default PayableSummary;



// WEBPACK FOOTER //
// ./src/components/PayableSummary.js